import React from 'react';
import '../../App.css';
import './hsbakmeter.css';
import FaceCamera from './components/faceCamera.clean';


function HSBakMeter() {
  return (
    <div className="hsbakmeter-container">
      <div className="hsbakmeter-title-block">
        <h1>De Huize Sjaars BakMeter</h1>
      </div>
      <div className="face-detection-section">
        <h2>Gezichtsdetectie</h2>
        <p className="face-detection-instructions">
          Houd je gezicht in beeld voor de camera.
        </p>
        <FaceCamera />
      </div>
    </div>
  );
}

export default HSBakMeter;